// Simple in-memory ring buffer of recent wallet operation timings

export interface TimingEntry {
  type: "tip" | "lightning_pay" | "lightning_receive" | "cashu_send" | "cashu_receive" | "convert";
  durationMs: number;
  timestamp: number;
  amount: number;
}

const MAX_ENTRIES = 50;
const timings: TimingEntry[] = [];

export function recordTiming(entry: TimingEntry) {
  timings.push(entry);
  if (timings.length > MAX_ENTRIES) timings.shift();
}

export function getRecentTimings(type?: TimingEntry["type"]): TimingEntry[] {
  if (!type) return [...timings];
  return timings.filter((t) => t.type === type);
}

export function getAverageMs(type?: TimingEntry["type"]): number | null {
  const entries = type ? timings.filter((t) => t.type === type) : timings;
  if (entries.length === 0) return null;
  return Math.round(entries.reduce((sum, e) => sum + e.durationMs, 0) / entries.length);
}

export function getLastTiming(type?: TimingEntry["type"]): TimingEntry | null {
  const entries = type ? timings.filter((t) => t.type === type) : timings;
  return entries.length > 0 ? entries[entries.length - 1] : null;
}

export function getTimingCount(): number {
  return timings.length;
}
